import SvgIcon from "./IconStatusCheck.svg?react";
const IconStatusCheck = SvgIcon;
export default IconStatusCheck;
